import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import FlexContainer from "./FlexContainer";
import styled from "styled-components";
import { AuthPageContent } from "./AuthComponents";

const GuestShell = styled(FlexContainer)`
    min-height: 100vh;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    background: linear-gradient(135deg, #0b0d15 0%, #171a22 55%, #252b3e 100%);
`;

/**
 * Background component for non-home, logged-out routes - /signUp, /login, /forgotPassword, /resetPassword.
 * Gradient background using DFM evening theme.
 */
class SignUpContainer extends Component {
    render() {
        const { appVariant, children } = this.props;

        return (
            <GuestShell alignItems="center" minHeight="100vh">
                <Header appVariant={appVariant} />
                <AuthPageContent>{children}</AuthPageContent>
                <Footer />
            </GuestShell>
        );
    }
}

export default SignUpContainer;
